import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TopUserRow } from '../models/sla.models';

const COLUMN_SIZE = 10;

@Component({
  selector: 'app-top-users-table',
  template: `
    <div class="table-scroll">
      @if (rows().length === 0) {
        <table class="sla-table">
          <thead>
            <tr>
              <th class="rank" scope="col">Rank</th>
              <th class="row-label" scope="col">User</th>
              <th scope="col">Tickets</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="3">No tickets in this period.</td>
            </tr>
          </tbody>
        </table>
      } @else {
        <div class="top-users-columns">
          <table class="sla-table top-users-table">
            <thead>
              <tr>
                <th class="rank" scope="col">Rank</th>
                <th class="row-label" scope="col">User</th>
                <th scope="col">Tickets</th>
              </tr>
            </thead>
            <tbody>
              @for (r of firstColumn(); track r.user; let i = $index) {
                <tr>
                  <td class="rank">{{ i + 1 }}</td>
                  <td class="row-label">{{ r.user }}</td>
                  <td class="num">{{ r.tickets }}</td>
                </tr>
              }
            </tbody>
          </table>
          @if (secondColumn().length > 0) {
            <table class="sla-table top-users-table">
              <thead>
                <tr>
                  <th class="rank" scope="col">Rank</th>
                  <th class="row-label" scope="col">User</th>
                  <th scope="col">Tickets</th>
                </tr>
              </thead>
              <tbody>
                @for (r of secondColumn(); track r.user; let i = $index) {
                  <tr>
                    <td class="rank">{{ i + 1 + columnSize }}</td>
                    <td class="row-label">{{ r.user }}</td>
                    <td class="num">{{ r.tickets }}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopUsersTable {
  readonly rows = input.required<TopUserRow[]>();
  readonly columnSize = COLUMN_SIZE;
  readonly firstColumn = computed(() => this.rows().slice(0, COLUMN_SIZE));
  readonly secondColumn = computed(() => this.rows().slice(COLUMN_SIZE));
}
